import * as TrackingService from "@omni/services/tracking/tracking.service";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { CartImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";
import {
    StepVariables,
    ToolContext,
    ToolStepTrackingInfo
} from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

export const track = (
    step: StepVariables,
    context: ToolContext,
    extra?: { cart: CartImpressionTrackingInfo }
) => {
    const event: AnalyticsEvent<ToolStepTrackingInfo> = {
        event: EventType.ToolStep,
        payload: {
            eventData: {
                ...step,
                ...context,
                ...extra
            }
        }
    };

    TrackingService.track(event);
};

export const trackSubmit = (
    step: StepVariables,
    context: ToolContext,
    extra?: object
) => {
    const event: AnalyticsEvent<ToolStepTrackingInfo> = {
        event: EventType.ToolStepSubmit,
        payload: {
            eventData: {
                ...step,
                ...context,
                ...extra
            }
        }
    };

    TrackingService.track(event);
};
